import { graphql } from '@/gql';

export const DELETE_BEWERTUNG = graphql(`
  mutation mitarbeiter_deleteRotationsplanBewertung($id: String!) {
    mitarbeiter_deleteRotationsplanBewertung(id: $id) {
      success {
        bewertungId
        details
      }
      error {
        message
      }
    }
  }
`);
